import { ReactComponent as BrandLogo } from "../../assets/keychron/Keychron.svg";

export const KEYCHRON_CS2TIMED_brandVariables = {
  client: "keychron-vs12i", // For picking wich leaderboard to show
  tenantId: "keychron-vs12i", // For picking wich leaderboard to show
  layoutKeyValue: "KEYCHRONCS2TIMED",
  brand: "keychron", // For scss
  gameStyle: "cs2timed", // For picking wich leaderboard to show
  eventCode: "keychron_test_march_2024", // Needed for fetching correct challenge
  challengeStatus: "ongoing",
  challengeGameType: "CSGO",
  brandLogo: BrandLogo,
  leaderboardLength: 7,
  prize: {
    nameOf: "win a", // will be marked in color
    typeOfItem: "KEYCHRON K10 V2", // will be added after nameOf
  },

  content: {
    generalHeadline: "Beat the fastest time!",
    generalHeadlineAlt: "Set the fastest time!",
    subHeadline: "Lorem ipsum...",
    overviewHeadline: "Dreamhack winter 2024 winners overview!",
    endscreenHeadline: "Thank you and congratulations to our",
    raffleText1: "All participants are in a raffle for a",
    raffleText2: "Keychron K10 V2 mechanical keyboard",
  },
};
